import HttpService from "@core/services/http/http.service";
import { UploadMedia, UploadMediaPayload } from "@app/types/upload.type";
import { RequestContentType } from "@core/services/http/http.type";
import { GetDetailResponse } from "@app/types";

class _UploadMediaService {
  public upload(uploadMedia: UploadMediaPayload, isShowLoading?: boolean) {
    return HttpService.post<GetDetailResponse<UploadMedia>>("/admin/api/v3/uploads", {
      body: { ...uploadMedia },
      requestContentType: RequestContentType.MULTIPART,
      isShowLoading,
    });
  }
}

const UploadMediaService = new _UploadMediaService();

export default UploadMediaService;
